import { render, staticRenderFns } from "./SchoolMap.vue?vue&type=template&id=bf4144f6&"
import script from "./SchoolMap.vue?vue&type=script&lang=js&"
export * from "./SchoolMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports